import { Banner, NavLink } from "@/components/styles";
import { usePathname } from "next/navigation";
import React from "react";

const Navbar = () => {
  const pathname = usePathname();

  return (
    <>
      <Banner>
        <div
          style={{
            padding: 0,
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: 36,
          }}
        >
          <NavLink href="/" $isActive={pathname === "/"}>
            Home
          </NavLink>
          <NavLink href="/gallery" $isActive={pathname === "/gallery"}>
            Gallery
          </NavLink>
          <NavLink href="/download" $isActive={pathname === "/download"}>
            Download
          </NavLink>
          <NavLink href="/banners" $isActive={pathname === "/banners"}>
            Banners
          </NavLink>
        </div>
      </Banner>
    </>
  );
};

export default Navbar;
